import React from 'react';
import { withStyles  } from '@material-ui/core/styles';
import MaterialUiDrawer from '@material-ui/core/Drawer';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    list: {
        width: 250,
    }
}));

export interface IProps {
    anchor: 'left' | 'right' | 'top' | 'bottom' | undefined;
    open: boolean;
    onClose?: () => void;
    children?: any;
    onClick?: () => void;
}

const SideMenu = (props: IProps) => {
    const classes = useStyles();
    const { children, open, anchor } = props;

    return (
        <MaterialUiDrawer open={open} anchor={anchor} onClose={props.onClose ? props.onClose : undefined}>
            <div className={classes.list} onClick={props.onClick ? props.onClick : undefined}>
                {children}
            </div>
        </MaterialUiDrawer>
    );
}

export default SideMenu;